export const environment = {
  production: true,
  test : false,
  token : false,
  redirectUri: 'https://m.galimberti.eu/callback',
  clientId: 'n01Nv4mv1JmmYkbafOIGoUl2cDbpW8cc',
};
